import * as React from "react";

import { ILegalProps, LegalBase, ButtonWrapper, Button } from "./Base";

const Navigation = (
  <ButtonWrapper>
    <Button href="/privacy/">Privacy</Button>
    <Button href="/terms/">Terms</Button>
    <Button href="/disclosures/" className="active">
      Disclosures
    </Button>
  </ButtonWrapper>
);

const Disclosures: React.SFC<ILegalProps> = (props: ILegalProps) => (
  <LegalBase
    title="Disclosures"
    byline="Last updated: October 19, 2018"
    content={DisclosuresProxyContentMarkdown}
    pretitle={Navigation}
  />
);

export default Disclosures;

const DisclosuresProxyContentMarkdown = `
**For non-broker communications**  
Say Technologies LLC ("Say") is a third party provider of shareholder engagement services to and on behalf of public companies. Brokerage Services are offered through Robinhood Financial LLC, ("RHF") a registered broker dealer (member SIPC) and clearing services through Robinhood Securities, LLC, ("RHS") a registered broker dealer (member SIPC). This message and its contents (collectively, this “Content”) is sent by the aforementioned issuer and provided for informational purposes only. This Content is not intended to provide financial, legal, tax or investment advice or recommendations. You are receiving this Content because you are a shareholder of the aforementioned issuer. This Content may contain insights and/or opinions that do not reflect the views of Say or any of its subsidiaries or affiliates including RHF and RHS. Say and its affiliates including RHF and RHS make no representations or warranties as to the suitability, accuracy, completeness, or timeliness of the Content provided, including any information provided by third parties. This is an automated message. If you want to contact us, please do not reply to this message but instead go to [partners@saytechnologies.com](mailto:partners@saytechnologies.com). Replies to this message will not be read or responded to.

**For communications from your broker(s)**  
**No Opt-Out** You may not opt-out of these communications because we are required to deliver them to you on behalf of your broker-dealer.

**Information about Systems Requirements** To participate in electronic delivery and receive all necessary documentation, you must have a valid email address on record and Internet access via a browser that is JavaScript-enabled.

Electronic delivery is provided free of charge from your broker-dealer; however, your online service provider may apply a charge. Documents may be provided in HyperText Markup Language (HTML), Portable Document Format (PDF), or other compatible formats.

In order to access PDF documents, you must have Adobe® Acrobat® Reader software or equivalent. Adobe® Acrobat® Reader is available for download at no cost at [http://www.adobe.com](http://www.adobe.com).

Please keep your email address current and notify your broker-dealer of any changes.
`;



// WEBPACK FOOTER //
// ./src/pages/Legal/Disclosures.tsx